import { SxProps, Theme } from 'components/base';
import { CSSProperties } from 'react';

export const selectedActionInputStyles = (theme: Theme) => ({
  background: '#FDD9D7',
  borderColor: theme.palette.error.main,
});

export const selectedNormalInputStyles = (theme: Theme) => ({
  background: theme.palette.grey['200'],
});

export const yesnoInputStyles = (theme: Theme) => ({
  backgroundColor: theme.palette.success.background,
  borderColor: theme.palette.success.main,
});

export const dottedDividerStyles = () => ({
  borderStyle: 'dotted',
  background: 'none',
  marginTop: '10px',
});

export const instructionTextStyle: SxProps = {
  fontSize: '14px',
  whiteSpace: 'normal',
  '& p:first-child': {
    marginTop: '0',
  },
};

export const imgUploadStyle: CSSProperties = {
  width: '100%',
  maxHeight: '500px',
  borderRadius: '4px',
  overflow: 'hidden',
  objectFit: 'contain',
};

export const absoluteCloseStyle: CSSProperties = {
  position: 'absolute',
  top: '5px',
  right: '5px',
};
